export default __webpack_public_path__ + "static/media/rounded-bus-3x.0ec3803b.webp";